<template>
    <div class="manage">
        <div style="margin: 0px;" class="top">

            <el-row>
                <el-col :span="24" class="table" style="margin: 0px;">
                    <div ref="height_top">
                        <el-table ref="tableRef" :data="tableData" :height="tableHeight"
                            @selection-change="handleSelectionChange"
                            :header-cell-style="{ 'background-color': '#e5e5e5' }" size="small" v-loading="loading"
                            style="width: 100%;" :row-class-name="tableRowClassName">
                            <el-table-column type="selection" width="55" header-align="center" align="center"
                                :selectable="selectable" />
                            <el-table-column prop="img" label="实图" width="100" header-align="center"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div v-if="scope.row.img.length <= 0">
                                        <div @click="preview(scope.row, scope.row.img)">
                                            <el-image style="" :src="require('@/assets/img/error_img.png')"
                                                loading="lazy" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div @click="preview(scope.row, scope.row.img)">
                                            <el-image :src="scope.row.img[0]" loading="lazy" />
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="stock_type_txt" label="货物状态" header-align="center" width="200"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="stock_type_txt_button">
                                        <span v-for="item in scope.row.stock_type_txt_list">
                                            <el-button class="A" size="small" text bg
                                                v-if="item == '二手' || item == '过保' || item == '包附破损'" style="">{{ item
                                                }}</el-button>
                                            <el-button class="C" size="small" text bg v-else color="#ff8a5c">{{
                                                item }}</el-button>
                                        </span>
                                    </div>
                                    <!-- <el-button-group class="ml-4">
										    <el-button size="small"/>
										    <el-button size="small" />
										    <el-button size="small" />
										  </el-button-group> -->
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="product-info">
                                        <div class="brand-name" >
                                            {{ scope.row.brand_name }}
                                        </div>
                                        <div class="product-name" >
                                            {{ scope.row.name }}
                                        </div>
                                        <div class="product-details" >
                                            <span class="detail-label">型号</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.model }}</span>
                                        </div>
                                        <div class="product-details" >
                                            <span class="detail-label">订货号</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.order_no }}</span>
                                        </div>
                                        <div class="product-details" v-if="scope.row.unit">
                                            <span class="detail-label">单位</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.unit }}</span>
                                        </div>
                                        <div class="product-user-type" v-if="scope.row.type_name">
                                            <span class="detail-label">用户类型</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.type_name }}</span>
                                        </div>
                                        <span
                                            v-if="!scope.row.brand_name && !scope.row.name && !scope.row.model && !scope.row.order_no">
                                            -
                                        </span>

                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="tsw_price" align="center" header-align="center" label="单价"
                                :width="td_width['tsw_price']" show-overflow-tooltip>

                                <template #default="scope">
                                    <el-tooltip placement="top">
                                        <template #content>
                                            <p>此信息由用户提供，仅供参考，请与发布用户核实！</p>
                                        </template>
                                        <span class="price-value">{{ scope.row.tsw_price }}</span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="inve_num" label="库存" :width="td_width['sur_num']" align="center"
                                header-align="center" show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="stock-cell">
                                        <span v-if="scope.row.isexpire == 1" class="stock-warning">
                                            库存不足
                                        </span>
                                        <span v-else class="stock-value"
                                            :class="{ 'stock-disabled': scope.row.isexpire == 1 }">{{ scope.row.inve_num
                                            }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="num" label="数量" width="230" align="center" header-align="center"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div style="margin: 10px" @click.stop @dblclick.stop>
                                        <el-input-number class="num-input" v-model="scope.row.num" :min="1"
                                            :max="scope.row.inve_num" @change="(val) => handleChange(scope.row, val)"
                                            @click.stop @dblclick.stop :disabled="scope.row.isexpire == 1" />
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="tsw_price" align="center" header-align="center" label="金额"
                                :width="td_width['tsw_price']" show-overflow-tooltip>
                                <template #default="scope">
                                    <span class="price-value">{{ scope.row.tsw_money }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column label="操作" width="80" header-align="center" align="center"
                                v-if="!isReorder">
                                <template #default="scope">
                                    <el-icon style="cursor: pointer; color: #f56c6c;font-size: 20px;" @click="handleDelete(scope.row)">
                                        <Delete />
                                    </el-icon>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                </el-col>

            </el-row>

            <!-- 底部合计区域 -->
            <el-row class="footer-bar">
                <el-col :span="20" class="footer-left">
                    <el-checkbox v-model="isCashOnDelivery" class="cash-delivery-checkbox">到付</el-checkbox>
                    <div class="address-display" @click="openAddressDialog">
                        <el-icon class="edit-icon"><Edit /></el-icon>
                        <el-icon class="address-icon"><LocationFilled /></el-icon>
                        <template v-if="selectedAddress">
                            <div class="address-content">
                                <span class="address-name">{{ selectedAddress.name }} {{ selectedAddress.phone }}</span>
                                <span class="address-detail-text">{{ selectedAddress.province }}{{ selectedAddress.city }}{{ selectedAddress.district }}{{ selectedAddress.detail }}</span>
                            </div>
                        </template>
                        <template v-else>
                            <span class="address-placeholder">请选择收货地址</span>
                        </template>
                    </div>
                    <el-input v-model="xd_remark" class="footer-remark" placeholder="请输入订单备注（选填）" />
                </el-col>
                <el-col :span="4" class="footer-right">
                    <div class="total-section">
                        <div class="freight-label">运费：</div>
                        <div class="freight-amount ">{{ isCashOnDelivery ? '¥0' : '¥10' }}</div>
                        <div class="total-label">总金额：</div>
                        <div class="total-amount">¥{{ totalAmount }}</div>
                    </div>
                    <el-button class="pay-btn" type="primary" @click="handlePay" :loading="paying">创建订单</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
    <examineImg ref="examineImg"></examineImg>

    <!-- 地址选择弹窗 -->
    <el-dialog v-model="showAddressDialog" :close-on-click-modal="false" :close-on-press-escape="false" title="选择收货地址" width="600px">
        <div class="address-list">
            <div v-for="(addr, index) in addressList" :key="index" class="address-item"
                :class="{ active: selectedAddressIndex === index }" @click="selectAddress(index)">
                <div class="address-info">
                    <div class="address-info-left">
                        <span class="address-name">{{ addr.name }}</span>
                        <span class="address-phone">{{ addr.phone }}</span>
                    </div>
                    <div class="action-buttons">
                        <el-button size="small" type="primary" @click.stop="editAddress(index)" class="edit-btn" icon="Edit"></el-button>
                        <el-button size="small" type="danger" @click.stop="deleteAddress(index)" class="delete-btn" icon="Delete"></el-button>
                    </div>
                </div>
                <div class="address-detail">{{ addr.province }}{{ addr.city }}{{ addr.district }}{{ addr.detail }}</div>
                <div class="address-actions">
                    <div v-if="addr.isDefault" class="default-tag">默认</div>
                </div>
            </div>
            <div v-if="addressList.length === 0" class="no-address-tip">
                <el-icon><Plus /></el-icon>
                <span>暂无收货地址，请点击下方按钮添加</span>
            </div>
            
        </div>
        <div class="add-address-btn" @click="openAddAddress">
            <el-icon><Plus /></el-icon>
            <span>新增地址</span>
        </div>
        <template #footer>
            <el-button @click="showAddressDialog = false">取消</el-button>
            <el-button type="primary" @click="confirmAddress">确认选择</el-button>
        </template>
    </el-dialog>

    <!-- 新增/修改地址弹窗 -->
    <el-dialog v-model="showAddAddress" :close-on-click-modal="false" :close-on-press-escape="false" :title="editingAddressIndex >= 0 ? '修改地址' : '新增地址'" width="500px">
        <el-form :model="newAddress" label-width="80px">
            <el-form-item label="收货人">
                <el-input v-model="newAddress.name" placeholder="请输入收货人姓名" />
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="newAddress.phone" placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item label="所在地区">
                <el-select v-model="newAddress.province_code" placeholder="省" style="width: 32%; margin-right: 2%;" @change="handleProvinceChange">
                    <el-option v-for="province in areaData" :key="province.code" :label="province.name" :value="province.code" />
                </el-select>
                <el-select v-model="newAddress.city_code" placeholder="市" style="width: 31%; margin-right: 2%;" @change="handleCityChange">
                    <el-option v-for="city in cityList" :key="city.code" :label="city.name" :value="city.code" />
                </el-select>
                <el-select v-model="newAddress.district_code" placeholder="区" style="width: 33%;" @change="handleDistrictChange">
                    <el-option v-for="district in districtList" :key="district.code" :label="district.name" :value="district.code" />
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址">
                <el-input v-model="newAddress.detail" type="textarea" :rows="2" placeholder="请输入详细地址" />
            </el-form-item>
            <el-form-item label="设为默认">
                <el-switch v-model="newAddress.isDefault" />
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="showAddAddress = false">取消</el-button>
            <el-button type="primary" @click="saveAddress">保存</el-button>
        </template>
    </el-dialog>

</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete, Plus, LocationFilled, Edit } from '@element-plus/icons-vue'
import '../../assets/user/index.css' //优化表格样式
import examineImg from '../public/img';
import areaData from '../../assets/data/area.json'
export default {
    components: {
        examineImg,
        Plus,
        LocationFilled,
        Edit
    },
    data() {

        return {
            areaData,
            cityList: [],
            districtList: [],
            SelectionChangeId: [],
            selectedRows: [],
            srcList: [],
            tableData: [],
            form: {
                name: '',
                userinfo: '',
                type: '',
            },
            loading: false,
            paying: false,
            total: 0,
            page: 1,
            tableHeight: 400,
            page_size: 120,
            user_id: '',
            isReorder: false,
            isCashOnDelivery: false,
            xd_remark: '',
            td_width: {
                brand_name: 300,
                tsw_price: 130,
                sur_num: 130,
                chat: 60,
                price: 80
            },
            // 地址相关
            showAddressDialog: false,
            showAddAddress: false,
            selectedAddressIndex: -1,
            editingAddressIndex: -1,
            addressList: [],
            newAddress: {
                name: '',
                phone: '',
                province: '',
                province_code: '',
                city: '',
                city_code: '',
                district: '',
                district_code: '',
                detail: '',
                isDefault: false
            }

        }
    },
    props: [],

    updated() {

    },


    mounted() {

    },

    activated() {

    },
    created() {
        this.tableHeight_fun()
        this.user_id = localStorage.getItem('user_id');
        // 检查是否有订单号参数，有则设置重新下单标志并隐藏删除按钮
        const pay_no = this.$route.query.pay_no;
        if (pay_no) {
            this.isReorder = true;
        }
        this.search();
        this.getAddressList();
    },
    watch: {

    },
    computed: {
        totalAmount() {
            return this.calcTotalAmount();
        },
        selectedAddress() {
            if (this.addressList.length > 0 && this.selectedAddressIndex >= 0 && this.selectedAddressIndex < this.addressList.length) {
                return this.addressList[this.selectedAddressIndex]
            }
            return null
        }
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.isexpire == 1) {
                return 'expired-row';
            }
            return '';
        },
        selectable(row, index) {
            return row.isexpire != 1;
        },
        preview(row, img) {
            this.srcList = [];
            var obj = this;
            img.forEach(function (item) {
                obj.srcList.push(item)
            })
            this.$refs['examineImg'].img_title = row;
            this.$refs['examineImg'].data = this.srcList;
            this.$refs['examineImg'].dialogTableVisible = true;
            this.$refs['examineImg'].imgBigUrl = this.srcList[0];
        },
        handleDelete(row) {
            ElMessageBox.confirm(
                '确认删除该商品？',
                '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
            )
                .then(() => {
                    this.$axios.post('/api/yunsys.Cart/delcart', { id: row.id })
                        .then(res => {
                            var res = res.data;
                            if (res.code !== 0) {
                                return ElMessage({
                                    message: res.msg,
                                    type: 'error',
                                    grouping: true
                                });
                            }
                            const index = this.tableData.findIndex(item => item.id === row.id);
                            if (index !== -1) {
                                this.tableData.splice(index, 1);
                                ElMessage.success('删除成功');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            return ElMessage({
                                message: '系统错误',
                                type: 'error',
                                grouping: true
                            });
                        });
                })
                .catch(() => { });
        },
        // 计算单行金额
        calcRowMoney(row) {
            if (row && row.num && row.tsw_price) {
                row.tsw_money = this.$bn.multiply(row.num, row.tsw_price, 2);
            }
        },
        // 计算总金额（只计算勾选行）
        calcTotalAmount() {
            let total = '0';
            this.selectedRows.forEach(item => {
                total = this.$bn.add(total, item.tsw_money || 0, 2);
            });
            // 如果不是到付，加上运费10元
            if (!this.isCashOnDelivery) {
                total = this.$bn.add(total, 10, 2);
            }
            return total;
        },
        handleSelectionChange(data) {
            var ids = [];
            data.forEach(function (item) {
                ids.push(item.id);
            })
            this.SelectionChangeId = ids;
            this.selectedRows = data;
        },
        handleChange(row, val) {
            // 更新单行金额
            this.calcRowMoney(row);
        },
        // 地址相关方法
        openAddressDialog() {
            this.showAddressDialog = true;
        },
        confirmAddress() {
            if (this.selectedAddressIndex < 0) {
                ElMessage.warning('请选择收货地址');
                return;
            }
            this.showAddressDialog = false;
        },
        selectAddress(index) {
            this.selectedAddressIndex = index;
        },
        handleProvinceChange(provinceCode, shouldReset) {
            if (shouldReset === undefined) shouldReset = true;
            if (shouldReset) {
                this.districtList = [];
            }
            const province = this.areaData.find(function (item) { return item.code === provinceCode; });
            if (province) {
                if (shouldReset) this.newAddress.province = province.name;
                this.cityList = province.children || [];
            } else {
                if (shouldReset) this.newAddress.province = '';
                this.cityList = [];
            }
        },
        handleCityChange(cityCode, shouldReset) {
            if (shouldReset === undefined) shouldReset = true;
            const province = this.areaData.find(function (item) { return item.code === this.newAddress.province_code; }.bind(this));
            if (province) {
                const city = province.children.find(function (item) { return item.code === cityCode; });
                if (city) {
                    if (shouldReset) this.newAddress.city = city.name;
                    this.districtList = city.children || [];
                } else {
                    if (shouldReset) this.newAddress.city = '';
                    this.districtList = [];
                }
            } else {
                this.districtList = [];
            }
        },
        handleDistrictChange(districtCode) {
            const province = this.areaData.find(function (item) { return item.code === this.newAddress.province_code; }.bind(this));
            if (province) {
                const city = province.children.find(function (item) { return item.code === this.newAddress.city_code; }.bind(this));
                if (city) {
                    const district = city.children.find(function (item) { return item.code === districtCode; });
                    if (district) {
                        this.newAddress.district = district.name;
                    } else {
                        this.newAddress.district = '';
                    }
                } else {
                    this.newAddress.district = '';
                }
            } else {
                this.newAddress.district = '';
            }
        },
        saveAddress() {
            var self = this;
            if (!self.newAddress.name || !self.newAddress.phone || !self.newAddress.province_code || !self.newAddress.city_code || !self.newAddress.district_code || !self.newAddress.detail) {
                ElMessage.warning('请填写完整的地址信息');
                return;
            }
            self.loading = true;
            if (!self.newAddress.district && self.newAddress.district_code) {
                const province = self.areaData.find(function (item) { return item.code === self.newAddress.province_code; });
                if (province) {
                    const city = province.children.find(function (item) { return item.code === self.newAddress.city_code; });
                    if (city) {
                        const district = city.children.find(function (item) { return item.code === self.newAddress.district_code; });
                        if (district) {
                            self.newAddress.district = district.name;
                        }
                    }
                }
            }
            var requestData = {
                name: self.newAddress.name,
                phone: self.newAddress.phone,
                province: self.newAddress.province,
                province_code: self.newAddress.province_code,
                city: self.newAddress.city,
                city_code: self.newAddress.city_code,
                district: self.newAddress.district,
                district_code: self.newAddress.district_code,
                detail: self.newAddress.detail,
                is_default: self.newAddress.isDefault ? 1 : 0
            };
            if (self.editingAddressIndex >= 0) {
                requestData.id = self.addressList[self.editingAddressIndex].id;
                self.$axios.post('/api/yunsys.Order/updateaddress', requestData)
                    .then(function (res) {
                        var data = res.data;
                        if (data.code !== 0) {
                            ElMessage.error(data.msg || '保存地址失败');
                            return;
                        }
                        if (self.newAddress.isDefault) {
                            self.addressList.forEach(function (addr) { addr.isDefault = false; });
                        }
                        self.addressList[self.editingAddressIndex] = Object.assign({}, self.addressList[self.editingAddressIndex], data.data);
                        ElMessage.success('地址修改成功');
                        self.resetAddressForm();
                    })
                    .catch(function (err) {
                        console.error('保存地址失败:', err);
                        ElMessage.error('系统错误');
                    })
                    .finally(function () {
                        self.loading = false;
                    });
            } else {
                self.$axios.post('/api/yunsys.Order/addaddress', requestData)
                    .then(function (res) {
                        var data = res.data;
                        if (data.code !== 0) {
                            ElMessage.error(data.msg || '保存地址失败');
                            return;
                        }
                        if (self.newAddress.isDefault) {
                            self.addressList.forEach(function (addr) { addr.isDefault = false; });
                        }
                        self.addressList.push(Object.assign({}, data.data));
                        self.selectedAddressIndex = self.addressList.length - 1;
                        ElMessage.success('地址添加成功');
                        self.resetAddressForm();
                    })
                    .catch(function (err) {
                        console.error('保存地址失败:', err);
                        ElMessage.error('系统错误');
                    })
                    .finally(function () {
                        self.loading = false;
                    });
            }
        },
        resetAddressForm() {
            this.newAddress = {
                name: '',
                phone: '',
                province: '',
                province_code: '',
                city: '',
                city_code: '',
                district: '',
                district_code: '',
                detail: '',
                isDefault: false
            };
            this.cityList = [];
            this.districtList = [];
            this.showAddAddress = false;
            this.editingAddressIndex = -1;
        },
        openAddAddress() {
            this.resetAddressForm();
            this.showAddAddress = true;
        },
        editAddress(index) {
            const addr = this.addressList[index];
            this.newAddress = {
                name: addr.name,
                phone: addr.phone,
                province: addr.province,
                province_code: String(addr.province_code || ''),
                city: addr.city,
                city_code: String(addr.city_code || ''),
                district: addr.district,
                district_code: String(addr.district_code || ''),
                detail: addr.detail,
                isDefault: addr.isDefault
            };
            this.editingAddressIndex = index;
            if (this.newAddress.province_code) {
                const province = this.areaData.find(function (item) { return item.code === this.newAddress.province_code; }.bind(this));
                if (province) {
                    this.cityList = province.children || [];
                    if (this.newAddress.city_code && province.children) {
                        const city = province.children.find(function (item) { return item.code === this.newAddress.city_code; }.bind(this));
                        if (city) {
                            this.districtList = city.children || [];
                        }
                    }
                }
            }
            this.showAddAddress = true;
        },
        deleteAddress(index) {
            var self = this;
            const addr = self.addressList[index];
            ElMessageBox.confirm('确定要删除该地址吗？', '确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(function () {
                    self.loading = true;
                    self.$axios.post('/api/yunsys.Order/deleteaddress', { id: addr.id })
                        .then(function (res) {
                            var data = res.data;
                            if (data.code !== 0) {
                                ElMessage.error(data.msg || '删除地址失败');
                                return;
                            }
                            self.addressList.splice(index, 1);
                            if (self.selectedAddressIndex === index) {
                                self.selectedAddressIndex = Math.max(0, self.addressList.length - 1);
                            }
                            ElMessage.success('地址删除成功');
                        })
                        .catch(function (err) {
                            console.error('删除地址失败:', err);
                            ElMessage.error('系统错误');
                        })
                        .finally(function () {
                            self.loading = false;
                        });
                })
                .catch(function () { });
        },
        getAddressList() {
            var self = this;
            self.$axios.post('/api/yunsys.Order/getaddress')
                .then(function (res) {
                    var data = res.data;
                    if (data.code !== 0) {
                        ElMessage.error(data.msg || '获取地址列表失败');
                        return;
                    }
                    self.addressList = data.data || [];
                    if (self.addressList.length > 0) {
                        var defaultIndex = -1;
                        for (var i = 0; i < self.addressList.length; i++) {
                            if (self.addressList[i].isDefault) {
                                defaultIndex = i;
                                break;
                            }
                        }
                        self.selectedAddressIndex = defaultIndex >= 0 ? defaultIndex : 0;
                    }
                })
                .catch(function (err) {
                    console.error('获取地址列表失败:', err);
                    ElMessage.error('系统错误');
                });
        },
        handlePay() {
            if (this.SelectionChangeId.length === 0) {
                ElMessage.warning('请选择商品！');
                return;
            }
            if (this.selectedAddressIndex < 0 || !this.selectedAddress) {
                ElMessage.warning('请选择收货地址');
                return;
            }
            if (this.paying) {
                return;
            }
            this.paying = true;
            ElMessageBox.confirm(
                '确认创建订单信息，需等待商家确认！',
                '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
            )
                .then(() => {
                    var goods = this.selectedRows.map(function (item) {
                        return {
                            id: item.id,
                            product_order_no: item.order_no,
                            num: item.num
                        };
                    });
                    const pay_no = this.$route.query.pay_no;
                    this.$axios.post('/api/yunsys.Order/addbills', { goods: goods, pay_no: pay_no, address_id: this.selectedAddress.id, freight_type: this.isCashOnDelivery ? 2 : 1, xd_remark: this.xd_remark })
                        .then(res => {
                            var res = res.data;
                            this.paying = false;
                            if (res.code !== 0) {
                                return ElMessage({
                                    message: res.msg,
                                    type: 'error',
                                    grouping: true
                                });
                            }
                            ElMessage.success('创建订单成功');
                            this.$router.push('/user?type=orderList');
                        })
                        .catch(err => {
                            console.log(err);
                            this.paying = false;
                            return ElMessage({
                                message: '系统错误',
                                type: 'error',
                                grouping: true
                            });
                        });
                })
                .catch(() => {
                    this.paying = false;
                })
            // 后续可添加支付逻辑
        },
        header_table(event) {
            if (event.column.property == 'header') {
                return { 'background-color': '#fff' }
            } else {
                return { 'background-color': '#e5e5e5' }
            }

        },
        grabble() {
            this.page = 1;
            this.search();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        tableHeight_fun() {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 150
                console.log(this.tableHeight)
            })
        },
        async search() {
            if (this.loading) {
                return false;
            }
            this.loading = true;
            const pay_no = this.$route.query.pay_no;
            const apiUrl = pay_no ? '/api/yunsys.Order/reorder' : '/api/yunsys.Cart/getcart';
            const params = pay_no ? { pay_no: pay_no } : {};
            await this.$axios.post(apiUrl, params)
                .then(async (res) => {
                    var res = res.data;
                    this.loading = false;
                    if (res.code !== 0) {
                        return ElMessage({
                            message: res.msg,
                            type: 'error',
                            grouping: true // 开启合并功能
                        });
                    }
                    var obj = this;
                    res.data.forEach(item => {
                        item.stock_type_txt_list = item.stock_type_txt.split("、");
                        item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
                        item.tsw_money = obj.$bn.multiply(item.num, item.tsw_price, 2);
                    });
                    this.tableData = res.data;
                    this.$nextTick(() => {
                        if (this.$refs.tableRef) {
                            this.$refs.tableRef.toggleAllSelection();
                        }
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    return ElMessage({
                        message: '系统错误',
                        type: 'error',
                        grouping: true // 开启合并功能
                    });
                });
        },

    }
}
</script>
<style lang="less" scoped>
:deep(thead tr:first-child .cell) {
    padding: 0px
}

:deep(.el-table__row .el-table__cell:nth-child(2)) {
    .el-tooltip {
        padding: 0px;
    }
}

.stock_type_txt_button .el-button {
    margin-right: 5px;
    font-size: 0.70rem !important;
    padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
    color: red !important;
    background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
    color: red;
    background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
    color: rgb(75, 212, 205);
    background-color: rgb(223, 255, 251) !important;
}

:deep(.el-input-group__append) {
    background: #ff8a5c;
}

:deep(.num-input .el-input__wrapper) {
    box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color)) inset !important;
}


:deep(.district .el-input-group__prepend) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.district .el-input-group__append) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.el-image) {
    border-radius: 3px;
    height: 100px;
    width: 100px;
    display: inline-block;
    display: flex;
}

:deep(.acquiesce .el-button) {

    border: 0;
}

:deep(.info .el-button:hover) {
    color: #fff;
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.name .el-button:hover) {
    color: #ff8a5c;
}

:deep(.name .el-button:active) {
    color: #ff8a5c;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #ff8a5c;
}

:deep(.el-form-item__label) {
    font-size: 13px;
}

:deep(.el-form-item) {

    margin-bottom: 8px;
}

:deep(.el-input-group__append) {

    background: #ff8a5c;
}

:deep(.expired-row) {
    background-color: #f5f5f5 !important;
    color: #999 !important;
}

:deep(.expired-row .el-input-number) {
    opacity: 0.5;
}

.logo_m {
    margin: 15px 0px 15px 0px;
    height: auto;
}



.product-tags {
    margin-bottom: 6px;
}

.product-tags .el-tag {
    margin-right: 6px;
    margin-bottom: 4px;
}

.brand-name {
    font-weight: bold;
    color: #333;
    font-size: 14px;
    margin-bottom: 4px;
}

.product-name {
    color: #666;
    font-size: 13px;
    margin-bottom: 4px;
}

.product-details {
    color: #999;
    font-size: 12px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
}

.detail-label {
    display: inline-block;
    width: 48px;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-character;
}

.label-colon {
    margin-right: 8px;
}

.detail-value {
    flex: 1;
}

.product-user-type {
    color: #666;
    font-size: 12px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.price-value {
    color: #ff8a5c;
    font-size: 16px;
    font-weight: bold;
}

.price-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.inquiry-btn {
    color: #ff8a5c;
    font-size: 13px;
    padding: 0;
}

.inquiry-btn:hover {
    color: #ff6b3d;
}

.off-shelf {
    color: #999;
    font-size: 12px;
}

.stock-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 4px;
}

.stock-value {
    font-size: 13px;
    color: #333;
}

.stock-disabled {
    color: #999;
}

.stock-warning {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    background-color: #fff1f0;
    color: #cf1322;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ffccc7;
}

/* 底部合计区域样式 */
.footer-bar {
    background: #fff;
    border-top: 1px solid #e8e8e8;
    padding: 8px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.footer-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 20px;
}

.footer-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
}

.total-section {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
}

.total-label {
    font-size: 14px;
    color: #666;
    font-weight: 500;
    white-space: nowrap;
}

.total-amount {
    font-size: 20px;
    color: #ff8a5c;
    font-weight: bold;
    white-space: nowrap;
}

.freight-label {
    font-size: 14px;
    color: #666;
    font-weight: 500;
    white-space: nowrap;
}

.freight-amount {
    font-size: 16px;
    color: #ff8a5c;
    font-weight: 500;
    white-space: nowrap;
    padding-right: 20px;
}

:deep(.cash-delivery-checkbox .el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.cash-delivery-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after) {
    border-color: #fff;
}

:deep(.cash-delivery-checkbox .el-checkbox__input.is-focus .el-checkbox__inner) {
    border-color: #ff8a5c;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
    color: #ff8a5c;
}
.pay-btn {
    background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
    border: none;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 36px;
    border-radius: 25px;
    box-shadow: 0 4px 12px rgba(255, 138, 92, 0.4);
    transition: all 0.3s ease;
}

.pay-btn:hover {
    background: linear-gradient(135deg, #ff6b3d 0%, #ff5a2b 100%);
    box-shadow: 0 6px 16px rgba(255, 138, 92, 0.5);
    transform: translateY(-2px);
}

.pay-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(255, 138, 92, 0.4);
}

/* 收货地址显示 */
.address-display {
    display: flex;
    align-items: center;
    margin-left: 20px;
    padding: 6px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 240px;
    background-color: #f5f7fa;
    border: 2px solid #e4e7ed;
    position: relative;
    overflow: hidden;
}

.address-corner {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, transparent 50%, #ff8a5c 50%);
}

.address-corner::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, transparent 50%, #f5f7fa 50%);
}

.edit-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    color: #ff8a5c;
    font-size: 14px;
    z-index: 10;
}

.address-icon {
    color: #ff8a5c;
    font-size: 20px;
    margin-right: 10px;
    flex-shrink: 0;
}

.address-display:hover {
    border-color: #ff8a5c;
    box-shadow: 0 2px 8px rgba(255, 138, 92, 0.2);
}

.address-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    min-height: 33px;
    justify-content: center;
}

.address-placeholder {
    color: #999;
    font-size: 13px;
    display: flex;
    align-items: center;
    flex: 1;
    min-height: 33px;
}

.address-name {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
}

.address-detail-text {
    font-size: 12px;
    color: #666;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.footer-remark {
    flex: 1;
    min-width: 0;
    max-width: 360px;
    margin-left: 20px;
}

.footer-remark :deep(.el-input__wrapper) {
    height: 46px;
    background-color: transparent;
    border: 2px solid #e4e7ed;
    border-radius: 6px;
    box-shadow: none;
    padding: 0 16px;
}

.footer-remark :deep(.el-input__inner) {
    height: 100%;
    border: none;
    background: transparent;
    font-size: 14px;
}

/* 地址选择弹窗样式 */
.address-list {
    max-height: 350px;
    overflow-y: auto;
}

.address-item {
    display: flex;
    flex-direction: column;
    padding: 15px;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 10px;
    transition: all 0.3s ease;
    background-color: #fafafa;
}

.address-item:hover {
    border-color: #ff8a5c;
    background-color: #fff;
}

.address-item.active {
    border-color: #ff8a5c;
    background-color: #fff8f5;
}

.address-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
}

.address-info-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
}

.address-item .address-name {
    font-size: 15px;
    font-weight: 600;
    color: #333;
}

.address-item .address-phone {
    font-size: 14px;
    color: #666;
}

.address-item .address-detail {
    font-size: 13px;
    color: #999;
    line-height: 1.5;
    margin-bottom: 10px;
    word-break: break-all;
}

.address-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.default-tag {
    background-color: #ff8a5c;
    color: #fff;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
}

.action-buttons {
    display: flex;
    gap: 8px;
}

.no-address-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #999;
    font-size: 14px;
    gap: 10px;
}

.no-address-tip .el-icon {
    font-size: 32px;
}

.add-address-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border: 2px dashed #ddd;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 10px;
    color: #999;
    font-size: 14px;
    transition: all 0.3s ease;
}

.add-address-btn:hover {
    border-color: #ff8a5c;
    color: #ff8a5c;
}

.chat-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected) td {
    border-top: 1px solid #ff8a5c !important;
    border-bottom: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:first-child) {
    border-left: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:last-child) {
    border-right: 1px solid #ff8a5c !important;
}

/* 多选框选中颜色 */
:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

/* 多选框移入边框颜色 */
:deep(.el-checkbox__input:hover .el-checkbox__inner) {
    border-color: #ff8a5c;
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
    .search_remark {
        width: 120px;
    }
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
    .search_remark {
        width: 170px;
    }
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
    .search_remark {
        width: 400px;
        margin-left: 60px
    }
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
    .search_remark {
        width: 400px;
        margin-left: 60px
    }
}
</style>